import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Modal, Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  deleteSuperBatchModuleModalStateSelector,
  selectedSuperBatchModuleSelector,
  setDeleteSuperBatchModuleModalState,
  setSelectedSuperBatchModule,
  useUpdateMenteeModuleFieldsMutation,
} from 'features/moduleManagement';
import GlobalLoader from 'components/GlobalLoader';

function DeleteSuperBatchModuleModal() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(deleteSuperBatchModuleModalStateSelector);
  const selectedMenteeModule = useSelector(selectedSuperBatchModuleSelector);
  const [updateSuperBatchModuleStatus, { error, isSuccess, isLoading }] =
    useUpdateMenteeModuleFieldsMutation();

  const handleOnClose = useCallback(() => {
    batch(() => {
      dispatch(setDeleteSuperBatchModuleModalState(false));
      dispatch(setSelectedSuperBatchModule(null));
    });
  }, [dispatch]);

  const handleConfirm = useCallback(() => {
    updateSuperBatchModuleStatus({
      id: selectedMenteeModule?.id,
      moduleType: selectedMenteeModule?.academy_module_type,
      interviewRequired: selectedMenteeModule?.interview_required,
      status: 'deleted',
    });
  }, [selectedMenteeModule, updateSuperBatchModuleStatus]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Module is successfully deleted!');
      batch(() => {
        dispatch(setDeleteSuperBatchModuleModalState(false));
        dispatch(setSelectedSuperBatchModule(null));
      });
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleOnClose}
      withoutHeader
      className="p-xs"
      canClose={!isLoading}
    >
      <GlobalLoader isVisible={isLoading} />
      <div className="bold dark m-b-10">Delete Module</div>
      <div>
        Are you sure you want to
        <span className="dark bold m-h-5">delete this Module?</span>
        It will reflect on learner dashboard for the whole super batch
      </div>
      <div className="m-t-xxs row">
        <Tappable
          onClick={handleConfirm}
          disabled={isLoading}
          className="btn btn-danger btn-long m-r-xs"
        >
          Yes
        </Tappable>
        <Tappable
          onClick={handleOnClose}
          disabled={isLoading}
          className="btn btn-inverted btn-long"
        >
          No
        </Tappable>
      </div>
    </Modal>
  );
}

export default DeleteSuperBatchModuleModal;
